module.exports = __webpack_public_path__ + "img/hz.cef3c569.png";